export enum FiltersFieldIds {
  OrderStatus = 'Incoming',
  OrderIncoming = 'OrderIncoming',
  PlacedPeriod = 'Date_order',
  OrderType = 'OrderType',
  Address = 'Address',
  DeliveryYear = 'DeliveryDate',
  DeliveryMonth = 'DeliveryDate_requested',
  Brand = 'BrandId',
  SubBrand = 'RootAttribute_productlinename',
  Category = 'RootAttribute_categoryname',
  Noos = 'RootAttribute_isglobalnoos',
  AccountId = 'AccountId',
  Division = 'RootAttribute_divisionb2b',
  MaterialGroup = 'RootAttribute_materialgroup',
}

export const standaloneFilters = [
  FiltersFieldIds.PlacedPeriod,
  FiltersFieldIds.DeliveryYear,
];

export const incomingFilterIds = [
  FiltersFieldIds.OrderStatus,
  FiltersFieldIds.OrderIncoming,
];

export interface DefaultFilterValue {
  value: string;
  displayName: string;
  alternativeValue?: string;
}

export type DefaultOrderBookFilters = Partial<
  Record<FiltersFieldIds, DefaultFilterValue[]>
>;

export interface OrderDetailFiltersSettings {
  categoryAttributeKey: string;
}
